import React, { useMemo } from 'react'
import { ConectionsStatusContainer, ConnectionStatussesContainer } from './ConnectionStatus.styled'
import { StyledText } from '@clickcease/cc-client-components-lib'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'
import { getStatusStringByBooleans } from './ConnectionSatus.utils'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { GLOBAL_MODALS } from 'Types/GlobalModal'
import { PlatformStatus } from './PlatformStatus'
import { useTranslation } from 'react-i18next'

export const ConnectionStatusBz = () => {
  const { t } = useTranslation('home')
  const { setCurrentDomain, setModalToShow } = useAppStore()
  const navigate = useNavigate()
  const { data: domains } = useGetDomains()

  const platform = useMemo(() => {
    if (!domains?.data) return { enabled: false, connected: false, wordpress: false }
    let enabled = false
    let connected = false
    let wordpress = false

    domains.data.domains.forEach((domain) => {
      if (domain.botZappingConnected) connected = true
      if (domain.botZappingPluginActivated) enabled = true
      if (domain.wordpress) wordpress = true
    })
    return {
      enabled,
      connected,
      wordpress,
    }
  }, [domains])

  const openPlatformWizard = () => {
    if (domains?.data?.domains && domains?.data?.domains.length === 1) {
      setCurrentDomain(domains.data.domains[0])
      setModalToShow(GLOBAL_MODALS.BM_SETUP)
    } else {
      navigate('/domain-management')
    }
  }

  return (
    <ConectionsStatusContainer>
      {platform.wordpress && (
        <>
          <StyledText variant={'baseLight'}>{t('connection_status')}</StyledText>
          <ConnectionStatussesContainer>
            <PlatformStatus
              key={'wordpress'}
              product={'wordpress'}
              status={getStatusStringByBooleans(platform.enabled, platform.connected)}
              onOpenModal={openPlatformWizard}
            />
          </ConnectionStatussesContainer>
        </>
      )}
    </ConectionsStatusContainer>
  )
}
